// extracted by mini-css-extract-plugin
module.exports = {"examination_title":"Appointment_examination_title__1mayF"};